// Предел выбранных публикаций — бэкенд не сохранит больше (task/11641).
export const MAX_SELECTED_INSTAGRAM_PUBLICATIONS = 100;

// Размер страницы списка публикаций. Ручка принимает не больше 50.
export const INSTAGRAM_PUBLICATIONS_PAGE_SIZE = 50;

// Сколько пикселей до конца сетки остаётся, когда пора грузить следующую страницу.
export const INSTAGRAM_PUBLICATIONS_LOAD_MORE_OFFSET_PX = 200;

export const INSTAGRAM_PUBLICATIONS_REQUIRED_ERROR =
  'Выберите хотя бы одну публикацию или переключитесь на «Все публикации»';

export const INSTAGRAM_PUBLICATIONS_LIMIT_ERROR = `Можно выбрать не больше ${MAX_SELECTED_INSTAGRAM_PUBLICATIONS} публикаций. Уберите лишние из выбора`;

// Шлюз начинает новый обход публикаций не чаще раза в 10 минут
// (instagram, app/services/official-instagram-api/import-posts.ts:95).
// PostsRefreshedAt — время начала обхода, а не конца.
export const POSTS_REFRESH_INTERVAL_MS = 10 * 60_000;
